import { AnyAction } from 'redux';
import { close, reduxFormWorksheet } from '@flowio/redux-form-overlay';
import { createToast } from '../../console/actions';

import FormNames from '../constants/FormNames';
import EditDisputeForm from '../components/EditDisputeForm/EditDisputeForm';
import updateDispute from '../actions/update-dispute';
import { ThunkDispatcher, RootActionTypes } from '../../../stores/types';
import { EditDisputeFormValues } from '../types';

function handleSubmit(
  values: EditDisputeFormValues,
  dispatch: ThunkDispatcher,
): Promise<void | io.flow.internal.v0.models.Dispute> {
  return dispatch(updateDispute(values.id, values));
}

function handleSuccess(
  action: AnyAction,
  dispatch: ThunkDispatcher,
): Promise<[RootActionTypes, any]> | RootActionTypes {
  if (action) {
    return Promise.all([
      dispatch(createToast({
        content: 'Successfully updated dispute - refresh for change',
        intent: 'positive',
      })),
      dispatch(close(FormNames.EDIT_DISPUTE_FORM)),
    ]);
  }

  return dispatch(createToast({
    content: 'Could not update dispute, please try again',
    intent: 'negative',
  }));
}

export default reduxFormWorksheet({
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  form: FormNames.EDIT_DISPUTE_FORM,
  onSubmit: handleSubmit,
  onSubmitSuccess: handleSuccess,
})(EditDisputeForm);
